export default __webpack_public_path__ + "static/waxing-vs-hero-3d0bea3be74350724cd5d973d55cee2c.webp";